import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { EventCardProps } from "./CombinedEventCard";
import { useAppStore } from "@/global/store";
import { selectPackageSelected } from "@/global/store/data/purchaseSeats/packages";
import {
  getSoldOutLabelAndColor,
  isEventValidInPackage,
  isEventWithinSeatLimit,
} from "@/shared/modules/PurchaseSeats/FindGames/utils.find-games";
import { selectUser } from "@/global/store/data/user";

export const useEventCardCommon = (props: EventCardProps) => {
  const teamConfig = useTeamConfig();
  const selectedPackage = useAppStore(selectPackageSelected);
  const user = useAppStore(selectUser);

  const isSoldOut = props?.event?.hasInventory === false;
  const isWithinSeatLimit = isEventWithinSeatLimit(props.event, teamConfig);
  const isValidInSelectedPackage = isEventValidInPackage(
    props.event,
    selectedPackage,
    teamConfig
  );
  const isDisabledEventSelection = teamConfig?.purchaseSeatConfigs?.isDisabledEventSelection; // prettier-ignore
  const isMarqueeDisabled = true;
  const soldOutLabelDetails = getSoldOutLabelAndColor(props?.event, teamConfig);

  const isDisabled =
    !isWithinSeatLimit ||
    !props?.event?.hasInventory ||
    !isValidInSelectedPackage ||
    isDisabledEventSelection ||
    props?.isDisabled;

  const isPreviewButtonEnabled =
    !props?.isInvPreviewButtonHidden &&
    (teamConfig?.purchaseSeatConfigs?.hidePreviewButtonIfNonAuthenticated &&
    !user
      ? false
      : typeof teamConfig?.purchaseSeatConfigs?.invPreviewAccountGroup !==
        "undefined");

  let eventDate = props?.event?.date;
  let eventTime = props?.event?.time;
  if (Boolean(teamConfig?.uiConfigs?.findGames?.eventDateTimeReplacement)) {
    const replacement =
      teamConfig?.uiConfigs?.findGames?.eventDateTimeReplacement?.find(
        (item) => item.eventCode === props?.event?.eventCode
      );
    if (replacement) {
      eventDate = replacement.label;
      eventTime = "";
    }
  }

  const customTagSize = teamConfig?.uiConfigs?.eventCardSettings?.customTagSize || "135px"; // prettier-ignore
  const customMarqueeMinLength = teamConfig?.uiConfigs?.eventCardSettings?.customMarqueeMinLength || 16; // prettier-ignore
  const hideSoldOutTag = teamConfig?.uiConfigs?.eventCardSettings?.hideSoldOutTag || false; // prettier-ignore

  return {
    isWithinSeatLimit,
    isDisabled,
    isMarqueeDisabled,
    eventDate,
    eventTime,
    isPreviewButtonEnabled,
    soldOutLabelDetails,
    isSoldOut,
    customTagSize,
    customMarqueeMinLength,
    hideSoldOutTag,
  };
};
